import React from 'react'; 
import {getIncidents} from '../utils/verticalEventHandling'
import QualdoDataTable from '../components/bootstrapTable';
import Load from '../components/loadAction';
import Image from "../components/image";

const SEVERITY_FILTER_OPTIONS = [
  { label: 'All Severities', value: 'All' },
  { label: 'Critical', value: 'Critical' },
  { label: 'High', value: 'Severe' },
  { label: 'Warning', value: 'Warning' },
  { label: 'Informational', value: 'Informational' },
];

export default class VerticalIncidentGrid extends React.Component {
  constructor(props) {
    super(props);
    
    this.state = {
      incidentTableData:"",
      incidentTableFilterData:"",
      selectedSeverity: "All",
      incidentData : this.props.incidentData
    }

    this.formatTableData   = this.formatTableData.bind(this)
    this.loadIncidentData  = this.loadIncidentData.bind(this)
    this.changeSeverityFilter = this.changeSeverityFilter.bind(this)
    this._isMounted = false;
  }



  async loadIncidentData(){
   let data_response = await this.getIncidentsResponse();
   if (!this._isMounted) {
     return;
   }

    if (data_response?.code === 200 && Array.isArray(this.props.incidentData) && this.props.incidentData.length > 0) {
      const isKpi = this.isKpiGrid();
      const aggregationKey = this.props.period_type
        ? (isKpi ? 'kpi_aggregation_incident' : 'metric_aggregation_incident')
        : null;
      const fallbackKey = isKpi ? 'kpi_incidents' : 'incident_details';
      const incidentKey = aggregationKey || fallbackKey;

      const existingIncidents = data_response.response?.[0]?.[incidentKey] || [];
      const mergedIncidents = [...this.props.incidentData, ...existingIncidents];

    

      data_response = {
        ...data_response,
        response: [
          {
            ...data_response.response?.[0],
            [incidentKey]: mergedIncidents,
          },
        ],
      };
    }


    if(data_response.code===200){
    if (!this._isMounted) {
      return;
    }
    this.setState({incidentResponseData: data_response,incident:data_response})
    
    let incidentDetails = [];
    const isKpi = this.isKpiGrid();
    const responseRoot = data_response.response?.[0] || {};

    const aggregationKey = this.props.period_type
      ? (isKpi ? 'kpi_aggregation_incident' : 'metric_aggregation_incident')
      : null;
    const primaryKey = aggregationKey || (isKpi ? 'kpi_incidents' : 'incident_details');
    const fallbackKeys = isKpi
      ? ['incident_details', 'kpi_incidents']
      : ['incident_details'];

    const primaryIncidentData = responseRoot[primaryKey];
    let fallbackIncidentData = null;

    for (const key of fallbackKeys) {
      if (Array.isArray(responseRoot[key]) && responseRoot[key].length > 0) {
        fallbackIncidentData = responseRoot[key];
        break;
      }
    }

    if (Array.isArray(primaryIncidentData) && primaryIncidentData.length > 0) {
      incidentDetails = primaryIncidentData;
    } else if (Array.isArray(fallbackIncidentData)) {
      incidentDetails = fallbackIncidentData;
    } else {
      incidentDetails = [];
    }


    
    if (this.normalizeIncidentDetails) {
      incidentDetails = this.normalizeIncidentDetails(incidentDetails);
    }

    let data1 = this.formatTableData(incidentDetails)
    // console.log('[VerticalIncidentGrid] formatted data', data1);
    this.setState({incidentTableData:incidentDetails,incidentTableFilterData:data1,incidentResponseData:data1})
    }else{
      if (!this._isMounted) {
        return;
      }
      let data1 = this.formatTableData([])
      this.setState({incidentTableData:[],incidentTableFilterData:data1,incidentResponseData:data1})
    }
  }

  changeSeverityFilter(selectedOption) {
    const severityValue = selectedOption?.value ?? selectedOption;
    this.setState({ selectedSeverity: severityValue });
  }

  isKpiGrid() {
    if (
      this.props.selectedLeftPanelType === "Dataset" ||
      this.props.selectedLeftPanelType === "Attribute"
    ) {
      return false;
    }
    return this.props.business_type === "KPI" || this.props.dataType === "KPI";
  }

  getRowIncident(row) {
    if (!Array.isArray(row)) {
      return null;
    }
    const nameIndex = 0;
    return row[nameIndex]?.value || row[0]?.value || null;
  }

  getRowMetrics(row) {
    if (!Array.isArray(row)) {
      return null;
    }
    const metricsIndex = this.isKpiGrid() ? 2 : 1;
    return row[metricsIndex]?.value;
  }

  getSeverityCounts(incidents = []) {
    const counts = { All: 0, Critical: 0, Severe: 0, Warning: 0, Informational: 0 };
    incidents.forEach((incident) => {
      counts.All += 1;
      const level = incident?.incident_level;
      if (level && Object.prototype.hasOwnProperty.call(counts, level)) {
        counts[level] += 1;
      }
    });
    return counts;
  }

  getSeverityFilterOptions() {
    const counts = this.getSeverityCounts(this.state.incidentTableData || []);
    const options = SEVERITY_FILTER_OPTIONS.map((option) => {
      const count = counts[option.value] ?? 0;
      const isAll = option.value === "All";
      return {
        label: `${option.label} (${count})`,
        value: option.value,
        disabled: !isAll && count === 0,
      };
    });

    const enabledOptions = options.filter((option) => !option.disabled);
    const disabledOptions = options.filter((option) => option.disabled);
    return [...enabledOptions, ...disabledOptions];
  }

  buildNameRowValue(incident) {
    const source = incident.source;
    const src = Array.isArray(source) ? (source[0] || {}) : (source || {});
    return {
      ...incident,
      name: incident.kpi_name || incident.name || "Incident",
      type: incident.type ?? 2,
      source: [{
        integration_name: src.integration_name,
        integration_id: src.integration_id,
        env_id: src.env_id,
        data_set_id: src.data_set_id,
        data_set_name: src.data_set_name,
      }],
    };
  }

  getIncidentsResponse(){

    if (
      this.props.selectedLeftPanelType === "Dataset" ||
      this.props.selectedLeftPanelType === "Attribute"
    ) {
      const datasetRequestParams = {
        tenant_id: this.props.teamId,
        env_id: this.props.selectedEnvId,
        start_date: this.props.incidentStartDate,
        end_date: this.props.incidentEndDate,
        integration_id: this.props.selectedIntegrationId || this.props.integrationId,
        user_id: this.props.userId,
        data_set_id: this.props.selectedDatasetId,
      };

      if (this.props.selectedLeftPanelType === "Attribute" && this.props.selectedDatasetAttrId) {
        datasetRequestParams.attribute_id = this.props.selectedDatasetAttrId;
      }

      return getIncidents(datasetRequestParams);
    }

   let requestParams = {
      tenant_id: this.props.teamId,
      env_id: this.props.selectedEnvId,
      user_id: this.props.userId,
      business_type: this.props.business_type || undefined,
      business_id: this.props.kpiId || undefined,
      data_set_id: this.props.selectedDatasetId || undefined,
      business_area_id: this.props.business_area_id || undefined,
      subject_area_id: this.props.subject_area_id || undefined,
      period_type:"refresh_level",
    };

    if (this.props.selectedWatchListId && this.props.selectedWatchlistName !== "All") {
      requestParams.watch_list_id = this.props.selectedWatchListId;
    }
    if (this.props.incidentStartDate) {
      requestParams.start_date = this.props.incidentStartDate;
    }
    if (this.props.incidentEndDate) {
      requestParams.end_date = this.props.incidentEndDate;
    }
    if (this.props.selectedIntegrationId || this.props.integrationId) {
      requestParams.integration_id = this.props.selectedIntegrationId || this.props.integrationId;
    }
    if (this.props.period_type) {
      requestParams.selected_period = this.props.period_type;
      requestParams.period_type = this.props.period_type;
      requestParams.meta_data_id = null;
    }
    // console.log('[VerticalIncidentGrid] incidents request', requestParams);
    return getIncidents(requestParams).then((response) => {
      // console.log('[VerticalIncidentGrid] incidents response', response);
      return response;
    });

      
  }


normalizeIncidentDetails = (incidentDetails = []) => {
    const normalized = [];
    const detailList = Array.isArray(incidentDetails) ? incidentDetails : [];

    detailList.forEach((incident) => {
      // console.log(incident);
      if (incident?.kpi_incident_id || incident?.kpi_agg_value !== undefined || incident?.kpi_name) {
        const normalizedSource = [
          {
            integration_id: this.props.selectedIntegrationId || incident.integration_id || null,
            integration_name: this.props.selectedIntegrationName || incident.integration_name || incident.business_name || "KPI Integration",
          },
          {
            data_set_id: this.props.selectedDatasetId || incident.data_set_id || incident.subject_name ||null,
            data_set_name: this.props.selectedDatasetName || incident.data_set_name || incident.subject_name || "Selected Dataset",
          },
        ];

        normalized.push({ 
          ...incident,
          generated_at: incident.created_time || incident.generated_at || incident.created_at,
          id: incident.kpi_incident_id || incident.id,
          is_child: false,
          name: incident.kpi_name || incident.name || "KPI Incident",
          source: normalizedSource,
          type: 2,
          metrics_details: [
            {
              condition: incident.kpi_threshold_condition || ">",
              metrics_id: incident.kpi_id || incident.id,
              metrics_name: incident.kpi_name || "KPI",
              threshold: Number(incident.kpi_threshold ?? 0),
              value: Number(incident.value ?? 0),
              kpi_agg_value: incident.kpi_agg_value,
              period_type_id: incident.period_type_id,
            },
          ],
        });
        return;
      }

      normalized.push(incident);
    });

    return normalized;
  };

  shouldComponentUpdate(nextProps, nextState) {
  if (
    nextProps.selectedDatasetId !== this.props.selectedDatasetId ||
    nextProps.selectedDatasetAttrId !== this.props.selectedDatasetAttrId ||
    nextProps.selectedMetricsId !== this.props.selectedMetricsId ||
    nextProps.selectedMeticsName !== this.props.selectedMeticsName ||
    nextProps.selectedLeftPanelType !== this.props.selectedLeftPanelType ||
    // nextProps.dataType !== this.props.dataType ||
    nextProps.business_type !== this.props.business_type ||
    nextProps.dataType !== this.props.dataType ||
    nextProps.kpiId !== this.props.kpiId ||
    nextProps.period_type !== this.props.period_type ||
    nextProps.incidentStartDate !== this.props.incidentStartDate ||
    nextProps.incidentEndDate !== this.props.incidentEndDate ||
    (nextProps.incidentData !== null && JSON.stringify(nextProps.incidentData) !== JSON.stringify(this.props.incidentData)) ||
    nextState.incidentTableData !== this.state.incidentTableData ||
    nextState.incidentTableFilterData !== this.state.incidentTableFilterData ||
    nextState.selectedSeverity !== this.state.selectedSeverity
  ) {
    return true; // allow re-render
  }
  return false; // prevent unnecessary re-render
}

  formatTableData(data) {
    const isKpi = this.isKpiGrid();
    const showOccurredAt = Boolean(this.props.period_type);
    const defaultHeaders = ["Name", "Incidents", "Identified at"];
    const kpiHeaders = ["KPI Name", "Subject Area", "Incidents", "Severity", "Identified at"];
    if (showOccurredAt) {
      defaultHeaders.push("Occurred at");
      kpiHeaders.push("Occurred at");
    }
    defaultHeaders.push("Source");
    kpiHeaders.push("Source");
    const headers = isKpi ? [...kpiHeaders] : defaultHeaders;
    const finalOpt = [];
    const today = new Date();
    const yesterday = new Date();
    yesterday.setDate(today.getDate() - 1);

    const formatDateTime = (dateStr) => {
      if (!dateStr) {
        return "";
      }
      const dateObj = new Date(dateStr);
      if (Number.isNaN(dateObj.getTime())) {
        return "";
      }

      const hours = String(dateObj.getHours()).padStart(2, '0');
      const minutes = String(dateObj.getMinutes()).padStart(2, '0');
      const seconds = String(dateObj.getSeconds()).padStart(2, '0');

      const time = `${hours}:${minutes}:${seconds}`;

      let dateLabel;
      if (dateObj.toDateString() === today.toDateString()) {
        dateLabel = 'Today';
      } else if (dateObj.toDateString() === yesterday.toDateString()) {
        dateLabel = 'Yesterday';
      } else {
        dateLabel = dateObj.toLocaleDateString('en-CA');
      }

      return `${dateLabel} ${time}`;
    };

    for (let i in data) {
      const incident = data[i];
      const row = [];
      const nameRowValue = this.buildNameRowValue(incident);

      if (isKpi) {
        row.push({ value: nameRowValue, type: "component" });
        row.push({ value: incident.subject_name || "N/A", type: "td" });
        row.push({ value: nameRowValue, type: "component" });
        row.push({ value: incident.incident_level || "", type: "component" });
        row.push({ value: formatDateTime(incident.generated_at), type: "td" });
        if (showOccurredAt) {
          row.push({ value: incident.occurred_at ? formatDateTime(incident.occurred_at) : "", type: "td" });
        }
        row.push({ value: nameRowValue, type: "component" });
      } else {
        row.push({ value: nameRowValue, type: "component" });
        row.push({ value: incident.metrics_details, type: "component" });
        row.push({ value: formatDateTime(incident.generated_at), type: "td" });
        if (showOccurredAt) {
          row.push({ value: incident.occurred_at ? formatDateTime(incident.occurred_at) : "", type: "td" });
        }
        row.push({ value: nameRowValue, type: "component" });
      }
      finalOpt.push(row);
    }

    return { headers, data: finalOpt };
  }

  async componentDidUpdate(prevProps, prevState) {
    if (
      prevProps.selectedDatasetId !== this.props.selectedDatasetId ||
      prevProps.selectedDatasetAttrId !== this.props.selectedDatasetAttrId ||
      prevProps.selectedLeftPanelType !== this.props.selectedLeftPanelType ||
      // prevProps.dataType !== this.props.dataType ||
      prevProps.business_type !== this.props.business_type ||
      prevProps.dataType !== this.props.dataType ||
      prevProps.kpiId !== this.props.kpiId ||
      prevProps.period_type !== this.props.period_type ||
      prevProps.incidentEndDate !== this.props.incidentEndDate ||
      prevProps.incidentStartDate !== this.props.incidentStartDate
    ) {
      this.loadIncidentData()
    }

    if(this.props.incidentData !== null && JSON.stringify(prevProps.incidentData) !== JSON.stringify(this.props.incidentData)){
      this.loadIncidentData()
    }
     if (prevProps.dataType !== this.props.dataType) {
        this.loadIncidentData();
  }
  } 

  async componentDidMount() {
    this._isMounted = true;
    this.loadIncidentData(this.state.incidentData);
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  render() {
    const { incidentTableFilterData, selectedSeverity } = this.state;
    const { selectedDatasetAttrId, selectedMetricsId, selectedDatasetId, selectedMeticsName } = this.props;
    const isKpi = this.isKpiGrid();
    const metricsIndex = isKpi ? 2 : 1;

    let filteredData = { headers: incidentTableFilterData?.headers || [], data: [] };

    if (incidentTableFilterData?.data) {
      if (this.isKpiGrid()) {
        if (this.props.kpiId) {
          filteredData = {
            headers: incidentTableFilterData.headers,
            data: incidentTableFilterData.data.filter((row) => {
              const incident = this.getRowIncident(row);
              return Number(incident?.kpi_id) === Number(this.props.kpiId);
            }),
          };
        } else {
          filteredData = incidentTableFilterData;
        }
      } else if (
        selectedDatasetAttrId &&
        selectedDatasetId &&
        selectedMetricsId &&
        selectedMeticsName &&
        this.props.dataType === "Attribute"
      ) {
        const [metricType, metricIdString] = selectedMetricsId.split("_");
        const metricIdNumber = Number(metricIdString);

        filteredData = {
          headers: incidentTableFilterData.headers,
          data: incidentTableFilterData.data
            .filter((row) => {
              const row0 = this.getRowIncident(row);
              const metricsArr = this.getRowMetrics(row);

              if (!row0 || !metricsArr) return false;
              let matchesRowId = false;

              if (metricType === "dataset") {
                matchesRowId = Number(row0.id) === Number(selectedDatasetId);
              }

              if (metricType === "attribute") {
                matchesRowId = Number(row0.id) === Number(selectedDatasetAttrId);
              }

              if (!matchesRowId) return false;
              return metricsArr.some(
                (metric) => Number(metric.metrics_id) === metricIdNumber
              );
            })
            .map((row) => {
              row[metricsIndex].value = row[metricsIndex].value.filter(
                (metric) => Number(metric.metrics_id) === metricIdNumber
              );
              return row;
            }),
        };
      } else if (selectedDatasetAttrId && selectedDatasetId && selectedMetricsId && selectedMeticsName) {
        const [metricType, metricIdString] = selectedMetricsId.split("_");
        const metricIdNumber = Number(metricIdString);

        filteredData = {
          headers: incidentTableFilterData.headers,
          data: incidentTableFilterData.data
            .filter((row) => {
              const row0 = this.getRowIncident(row);
              const metricsArr = this.getRowMetrics(row);

              if (!row0 || !metricsArr) return false;
              let matchesRowId = false;

              if (metricType === "dataset") {
                matchesRowId = Number(row0.id) === Number(selectedDatasetId);
              }

              if (metricType === "attribute") {
                matchesRowId = Number(row0.id) === Number(selectedDatasetAttrId);
              }

              if (!matchesRowId) return false;
              return metricsArr.some(
                (metric) => Number(metric.metrics_id) === metricIdNumber
              );
            })
            .map((row) => {
              row[metricsIndex].value = row[metricsIndex].value.filter(
                (metric) => Number(metric.metrics_id) === metricIdNumber
              );
              return row;
            }),
        };
      } else if (selectedDatasetAttrId && this.props.dataType === "Attribute") {
        filteredData = {
          headers: incidentTableFilterData.headers,
          data: incidentTableFilterData.data.filter((row) => {
            const incident = this.getRowIncident(row);
            return Number(incident?.id) === Number(selectedDatasetAttrId);
          }),
        };
      } else if (selectedDatasetId && selectedMetricsId) {
        const [metricType, metricIdString] = selectedMetricsId.split("_");
        const metricIdNumber = Number(metricIdString);
        filteredData = {
          headers: incidentTableFilterData.headers,
          data: incidentTableFilterData.data
            .filter((row) => {
              const row0 = this.getRowIncident(row);
              const metricsArr = this.getRowMetrics(row);

              if (!row0 || !metricsArr) return false;
              let matchesRowId = false;

              if (metricType === "dataset") {
                matchesRowId = Number(row0.id) === Number(selectedDatasetId);
              }

              if (!matchesRowId) return false;
              if (!Array.isArray(metricsArr)) return false;

              return metricsArr.some(
                (metric) => Number(metric.metrics_id) === metricIdNumber
              );
            })
            .map((row) => {
              row[metricsIndex].value = row[metricsIndex].value.filter(
                (metric) => Number(metric.metrics_id) === metricIdNumber
              );
              return row;
            }),
        };
      } else if (selectedDatasetId) {
        filteredData = {
          headers: incidentTableFilterData.headers,
          data: incidentTableFilterData.data.filter((row) => {
            const incident = this.getRowIncident(row);
            const source = incident?.source;
            const sourceDataSetId =
              source?.find?.((item) => Number.isFinite(Number(item?.data_set_id)))?.data_set_id ??
              source?.find?.((item) => Number.isFinite(Number(item?.[0]?.data_set_id)))?.[0]?.data_set_id ??
              incident?.data_set_id ??
              incident?.id;

            return Number(sourceDataSetId) === Number(selectedDatasetId);
          }),
        };
      } else if (selectedMetricsId && this.props.dataType === "Attribute") {
        filteredData = {
          headers: incidentTableFilterData.headers,
          data: incidentTableFilterData.data.filter((row) => {
            const incident = this.getRowIncident(row);
            const metricArray = this.getRowMetrics(row);

            return (
              Number(incident?.id) === Number(selectedDatasetAttrId) &&
              Array.isArray(metricArray) &&
              metricArray.some(
                (metric) => metric?.metrics_id === selectedMetricsId && metric?.metrics_name === selectedMeticsName
              )
            );
          }),
        };
      } else {
        filteredData = incidentTableFilterData;
      }

      if (selectedSeverity && selectedSeverity !== "All") {
        filteredData = {
          headers: filteredData.headers,
          data: filteredData.data.filter((row) => {
            const incident = this.getRowIncident(row);
            return incident?.incident_level === selectedSeverity;
          }),
        };
      }
    }

    const isTableReady = incidentTableFilterData && typeof incidentTableFilterData === "object" && Array.isArray(incidentTableFilterData.headers);

    return (
      <>
        {!isTableReady ? (
          <Load />
        ) : filteredData?.data?.length === 0 ? (
          <div className="row text-center">
            <div className="col-md-8 offset-md-2 col-lg-6 offset-lg-3">
              <div className="placeholder-msg">
                <div className="placeholder-msg__icon">
                  <Image src="icon_placeholder_no_pipeline_data" />
                </div>
                <p>{this.getEmptyMessage()}</p>
              </div>
            </div>
          </div>
        ) : (
          <QualdoDataTable
            id="dqincidentgrid"
            data={filteredData}
            component_name="dqincidentgrid"
            business_type={isKpi ? "KPI" : "MODEl"}
            dataType={isKpi ? "KPI" : this.props.dataType}
            hideViewFilter={true}
            showSeverityFilter={true}
            severityFilterOptions={this.getSeverityFilterOptions()}
            selectedSeverity={this.state.selectedSeverity}
            changeSeverityFilter={this.changeSeverityFilter}
            pageListRenderer={0}
            paginationSize={5}
            focusChart={this.props.focusChart}
          />
        )}
      </>
    );
  }

  getEmptyMessage() {
    const { selectedSeverity } = this.state;
    if (selectedSeverity && selectedSeverity !== "All") {
      const label = SEVERITY_FILTER_OPTIONS.find((option) => option.value === selectedSeverity)?.label || selectedSeverity;
      return `No ${label} incidents found`;
    }
    return "No Incidents Found";
  }
}
